<!--模板界面-->
<template>
	<div>
		<p class="bigTitle">在线支持</p>
		<div class="flexStart">
			<p class="infoTitle">一次设备：</p>
			<p v-for="item in oneDevice" :class="['info',{'isCheck':nowOneDevice == item}]" @click="nowOneDevice = nowOneDevice == item?undefined:item">{{item}}</p>
		</div>
		<div class="flexStart">
			<p class="infoTitle">二次设备：</p>
			<p v-for="item in twoDevice" :class="['info',{'isCheck':nowTwoDevice == item}]" @click="nowTwoDevice = nowTwoDevice == item?undefined:item">{{item}}</p>
		</div>
		<div class="flexStart">
			<p class="infoTitle">试&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;验：</p>
			<p v-for="item in test" :class="['info',{'isCheck':nowTest == item}]" @click="nowTest =  nowTest == item?undefined:item">{{item}}</p>
		</div>
		<div class="nomalButton" @click="search">查找</div>
		
		<infoListDialog v-show="isShow" :isShow="isShow" :keyword="keyword" :dataList="dataList" @closeDialog="isShow = false"></infoListDialog>
		
	</div>
</template>

<script>
	import infoListDialog from '@/page/projectDingZhi/Ubiquitous/infoListDialog.vue'
	
	export default {
		components: {
			infoListDialog
		},
		props: {},
		data() {
			return {
				"oneDevice": [],
				"twoDevice": [],
				"test": [],
				nowOneDevice: undefined,
				nowTwoDevice: undefined,
				nowTest: undefined,
				isShow: false,
				keyword: '',
				dataList: [],
			}
		},
		created() {},
		mounted() {
			var axios = require('axios')
			axios({
				url: "/static/中科泛在定制/看板/数据/info.json",
			}).then(respon => {
				var data = JSON.parse(JSON.stringify(respon.data))
				eachObject(data.onlineSupport, (value, key) => {
					this[key] = value
				})
				this.dataList = data.supportDataList.dataList
			})
		},
		destroyed() {},
		computed: {
			
		},
		watch: {
			nowOneDevice() {
				this.keyword = [this.nowOneDevice, this.nowTwoDevice, this.nowTest].join('  ')
			},
			nowTwoDevice() {
				this.keyword = [this.nowOneDevice, this.nowTwoDevice, this.nowTest].join('  ')
			},
			nowTest() {
				this.keyword = [this.nowOneDevice, this.nowTwoDevice, this.nowTest].join('  ')
			},
		},
		methods: {
			search(){
				this.isShow = true
			}
		}
	}
</script>

<style scoped>
	.onlineSupport{
		position: relative;
	}
	.onlineSupport p {
		color: white;
		font-weight: 500;
	}
	.onlineSupport .nomalButton {
		position: absolute;
		right: 30px;
		bottom: 15px;
	}

	.onlineSupport .flexStart {
		margin-top: 7px;
	}

	p.infoTitle {
		font-size: 16px;
		color: #80BFEC;
		margin-left: 28px;
	}

	p.info {
		text-align: center;
		cursor: pointer;
		padding: 2px 12px;
		margin-left: 40px;
		border-radius: 5px;
		border: 1px solid rgba(0, 0, 0, 0);
	}

	p.info.isCheck {
		background: #6083D2;
		border: 1px solid #6BBFFF;
	}

	p.bigTitle {
		width: 100%;
		color: #00C6FF;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		margin-top: 15px;
		margin-bottom: 20px;
	}
</style>
